import { z } from 'zod';
import { UserApi } from '../../Users/models';

export interface RequestApi {
  id: string;
  adminId: string;
  userId: string;
  adminFullName?: string;
  userFullName?: string;
  admin?: Pick<UserApi, 'id' | 'fullName'>;
  user?: Pick<UserApi, 'id' | 'fullName'>;
  type: string;
  assetType?: {
    id: string;
    name: string;
  };
  otherType?: string;
  note?: string;
  neededAt?: string;
  status: string;
  handledBy?: string;
  responseNote?: string;
  createdAt?: string;
  updatedAt?: string;
  assignedAssetId?: string;
  assignedAsset?: {
    id: string;
    type: string;
    brand: string;
    model: string;
    serialNumber: string;
  };
}

export const RequestSchema = z.object({
  adminId: z.string().optional(),
  userId: z.string().min(1, 'El ID del usuario no puede estar vacío.'),
  type: z.string().min(1, 'El tipo de solicitud es obligatorio.'),
  otherType: z.string().optional(),
  note: z.string().optional(),
  neededAt: z.union([z.date(), z.string()]).optional(),
  status: z.string().min(1, 'El estado es obligatorio.'),
  handledBy: z.string().optional(),
  responseNote: z.string().optional(),
});

export type RequestSchema = z.infer<typeof RequestSchema>;

export const defaultValues: RequestSchema = {
  adminId: undefined,
  userId: '',
  type: '',
  otherType: '',
  note: '',
  status: '',
  handledBy: '',
  responseNote: '',
};
